import React from 'react';
import { useTranslation } from 'react-i18next';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface ServerSetupTooltipContentProps {
  accountType?: string | null;
  hasHostname?: boolean;
}

const ServerSetupTooltipContent: React.FC<ServerSetupTooltipContentProps> = ({
  accountType = null,
  hasHostname = false,
}) => {
  const { t: tSettings } = useTranslation('settings', {
    keyPrefix: 'nameServerAndIPCard.advHostingServerInfo',
  });
  const isManagedAdvancedCpanelHosting =
    accountType === 'vps_cpanel' || accountType === 'dedicated_cpanel';
  const isNonCpanelVps = accountType === 'vps';
  const showHostnameAndPtrSteps = !hasHostname || isNonCpanelVps;

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2">
        {tSettings('serverSetup.helperText2')}
      </Typography>
      <Typography variant="body2">
        {tSettings('serverSetup.setMainDomain')}
      </Typography>
      {showHostnameAndPtrSteps && (
        <>
          <Typography variant="body2">
            {tSettings('serverSetup.setServer')}
          </Typography>
          <Typography variant="body2">
            {tSettings('serverSetup.createPTRRecords')}
          </Typography>
        </>
      )}
      {isManagedAdvancedCpanelHosting && (
        <>
          <Typography variant="body2">
            {tSettings('serverSetup.createCpanelAccount')}
          </Typography>
          <Typography variant="body2">
            {tSettings('serverSetup.createARecords')}
          </Typography>
        </>
      )}
    </Stack>
  );
};

export default ServerSetupTooltipContent;
